import { API, axios } from '@Root/API'

export const getStatic = () => {
  return Promise.all([API.admin.institution.getRelated(), getTypes()])
}

const getTypes = () => {
  return axios.get(`association-types`)
}
